export default __webpack_public_path__ + "static/media/white03.6571f7ab.jpg";